import { defineStore } from 'pinia';
import { StoreModuleName } from '../../constants';
import { AppSetting, AppTheme } from './types';

export const useAppSettingStore = defineStore(StoreModuleName.APP_SETTING, () => {
  const appSetting = ref<AppSetting>({
    theme: 'light',
  });

  const updateAppTheme = (theme: AppTheme) => {
    appSetting.value.theme = theme;
  };

  return {
    appSetting,
    updateAppTheme,
  };
});
